// @flow
import React from 'react';
import { Box, Heading, Text } from 'gestalt';

type Section = {
  heading: string,
  subtitle: string,
};

type Props = {
  title: string,
  sections: Array<Section>,
};

const SectionBlock = ({ heading, subtitle }: Section) => (
  <Box marginBottom={2} paddingY={3} width={275}>
    <Heading size="lg" color="darkGray">
      {heading}
    </Heading>
    <Text size="lg" color="gray" bold overflow="normal">
      {subtitle}
    </Text>
  </Box>
);

const CreateAccountValueProp = ({ title, sections }: Props) => (
  <Box marginLeft={7} marginTop={7}>
    <Box>
      <Text color="red" size="lg" bold>
        {title}
      </Text>
    </Box>
    <Box display="flex" direction="column">
      {sections.map((section: Section, index: number) => (
        <SectionBlock key={index} heading={section.heading} subtitle={section.subtitle} />
      ))}
    </Box>
  </Box>
);

export default CreateAccountValueProp;
